'use client';

import * as React from 'react';
import { IconChevronLeft } from 'icon/Arrows/chevron-left';
import { IconChevronRight } from 'icon/Arrows/chevron-right';
import { DayPicker } from 'react-day-picker';
import { cn } from '../utils';
import { buttonVariants } from './button';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center',
        // title. e.g. May 2025
        caption_label: 'text-md font-semibold text-secondary',
        nav: 'space-x-1 flex items-center',
        nav_button: cn(
          buttonVariants({ variant: 'outline' }),
          'size-8 bg-transparent p-0',
        ),
        nav_button_previous: 'absolute! left-1',
        nav_button_next: 'absolute! right-1',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell: 'text-secondary w-10 text-sm font-medium',
        row: 'flex w-full mt-2',
        cell: 'text-center text-sm p-0 relative first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20',
        day: cn(
          buttonVariants({ variant: 'ghost' }),
          'size-10 rounded-full p-0 font-normal text-secondary aria-selected:opacity-100',
        ),
        day_selected:
          'bg-brand-600 text-white hover:bg-brand-700! hover:text-white! focus:bg-brand-700 focus:text-white',
        day_today: 'border',
        day_outside: '',
        day_disabled: 'text-gray-500 opacity-50 dark:text-gray-400',
        day_range_middle:
          'aria-selected:bg-gray-100 aria-selected:text-gray-900 dark:aria-selected:bg-gray-800 dark:aria-selected:text-gray-50',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: () => <IconChevronLeft className="size-5 shrink-0" />,
        IconRight: () => <IconChevronRight className="size-5 shrink-0" />,
        // Day,
      }}
      showOutsideDays={showOutsideDays}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
